import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const VENDING_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.VENDING_TRANSACTION_VOLUME_BY_STATE_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.VENDING },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }
    ],
    groupBy: ChartQueryParam.STATE,
    groupByMode: ChartGroupByMode.VALUE
};
